const AuthSyncer = require('@/lib/Syncing/Syncers/AuthSyncer');
const EntraIDAuthService = require('@/lib/Auth/EntraIDAuthService');
const EposDataSyncer = require('@/lib/Syncing/Syncers/EposDataSyncer');
const ItemsSyncer = require('@/lib/Syncing/Syncers/ItemsSyncer');
const KitchenDataSyncer = require('@/lib/Syncing/Syncers/KitchenDataSyncer');
const PrivilegesSyncer = require('@/lib/Syncing/Syncers/PrivilegesSyncer');

/**
 * Downloading data now happens in multiple Syncer classes. So the purpose of this class is to provide
 * a single point to do things that happen across multiple Syncers.
 */
class SyncedDataManager {
    /**
     * @param localStorageDataStore
     * @param {SyncRunner} syncRunner
     */
    constructor(
        localStorageDataStore,
        syncRunner,
    ) {
        this.localStorageDataStore = localStorageDataStore;
        this.syncRunner = syncRunner;
    }

    /**
     * Remove all synced data.
     * This does not remove data that should be persistent, like offline tasks, as those tables are not listed
     * as managed by any syncer.
     */
    async clearData() {
        this.localStorageDataStore.remove(EntraIDAuthService.CACHE_KEY);

        await Promise.all(
            [
                this.syncRunner.getSyncerInstance(EposDataSyncer).clear(),
                this.syncRunner.getSyncerInstance(ItemsSyncer).clear(),
                this.syncRunner.getSyncerInstance(PrivilegesSyncer).clear(),

                this.syncRunner.getSyncerInstance(KitchenDataSyncer).clear(),

                // This does not clear the authenticated user. It clears the flags that say when the user
                // and current device were last synced. If those values are not present then AuthSyncer
                // will pull in the latest data for the user and device on startup.
                this.syncRunner.getSyncerInstance(AuthSyncer).clear(),
            ]
        );
    }
}

module.exports = SyncedDataManager;
